export const SITE_BASE_URL = import.meta.env.VITE_SITE_BASE_URL?.trim() || 'https://motexa.top'
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL?.trim() || 'https://api.motexa.top'
export const DOWNLOAD_BASE_URL = import.meta.env.VITE_DOWNLOAD_BASE_URL?.trim() || 'https://download.motexa.top'
export { LANZOU_DOWNLOAD_URL, LANZOU_DOWNLOAD_PASSWORD } from '../../../app/src/app/update/downloadFallback'

const DOWNLOAD_HOSTS = new Set([
  'download.motexa.top',
  'gitee.com',
  'github.com',
  'objects.githubusercontent.com',
  'release-assets.githubusercontent.com',
])

export const isAllowedDownloadUrl = (value: string): boolean => {
  try {
    const url = new URL(value)
    return url.protocol === 'https:' &&
      url.username === '' &&
      url.password === '' &&
      (url.port === '' || url.port === '443') &&
      url.pathname.toLowerCase().endsWith('.apk') &&
      DOWNLOAD_HOSTS.has(url.hostname.toLowerCase())
  } catch {
    return false
  }
}

export const downloadPath = (channel: 'stable' | 'beta', filename: string): string =>
  `${DOWNLOAD_BASE_URL.replace(/\/$/, '')}/downloads/${channel}/${filename}`
